import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const StepBranch = ({ branches, onSelect }) => {
    const { t } = useTranslation();

    if (!branches || branches.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="fa fa-store fa-3x text-muted mb-3"></i>
                <p className="text-muted">Nenhuma filial disponível no momento.</p>
            </div>
        );
    }

    return (
        <div className="step-branch">
            <div className="step-header mb-4">
                <h4 className="step-title">
                    <i className="fa fa-store me-2 text-primary"></i>
                    Selecione a filial
                </h4>
                <p className="step-subtitle text-muted">
                    Escolha a filial onde deseja fazer seu pedido.
                </p>
            </div>

            <Row className="g-3">
                {branches.map((branch) => (
                    <Col md={6} lg={4} key={branch.id}>
                        <Card
                            className="branch-card h-100"
                            onClick={() => onSelect(branch)}
                        >
                            <Card.Body className="text-center p-4">
                                <div className="branch-icon mb-3">
                                    <i className="fa fa-building fa-2x"></i>
                                </div>
                                <h5 className="mb-2">{branch.name}</h5>
                                {branch.address && (
                                    <p className="text-muted small mb-0">
                                        <i className="fa fa-map-marker-alt me-1"></i>
                                        {typeof branch.address === 'object'
                                            ? [branch.address.street, branch.address.number, branch.address.neighborhood, branch.address.city, branch.address.state].filter(Boolean).join(', ')
                                            : branch.address}
                                    </p>
                                )}
                                {branch.phone && (
                                    <p className="text-muted small mb-0 mt-1">
                                        <i className="fa fa-phone me-1"></i>
                                        {branch.phone}
                                    </p>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default StepBranch;
